import { Panel } from '../ui/Panel';
import { POSTS_PER_WEEK, pillars } from './socialOptions';
import { plural } from '../../core/format/text';
import type { PillarKey, SocialPost } from '../../core/types/social';
type Props = {
  /** Posts in de getoonde week. */
  week: SocialPost[];
  /** Posts rond deze week (± twee weken), voor de mix. */
  around: SocialPost[];
};

/** Boven dit aandeel product + aanbod wordt de feed een verkoopkanaal. */
const MAX_SELLING_SHARE = 0.45;

/** Houdt het ritme en de mix bewaakt: geen contentmachine, wel regelmaat. */
export function MixPanel({
  week,
  around
}: Props) {
  const planned = week.filter(p => p.status !== 'idee').length;
  const ready = week.filter(p => p.status === 'klaar').length;
  const counted = around.filter(p => p.status !== 'idee');
  const total = counted.length || 1;
  const share = (k: PillarKey) => counted.filter(p => p.pillar === k).length / total;
  const selling = share('product') + share('aanbod');
  const advice = counted.length === 0 ? 'Nog niets ingepland rond deze week. Begin met één huidtip: daar volgen ze je om.' : selling > MAX_SELLING_SHARE ? 'Veel product en aanbod. Wissel af met huidkennis of achter de schermen: dat bouwt vertrouwen.' : share('kennis') === 0 ? 'Nog geen huidkennis ingepland. Juist daar wordt je vakmanschap zichtbaar.' : share('achter') === 0 ? 'Mooie mix. Een kijkje achter de schermen maakt het persoonlijker.' : 'Mooie mix: vakkennis, jijzelf en af en toe het aanbod.';
  return <Panel title="Ritme & mix" description={`Je ritme: ${POSTS_PER_WEEK} berichten per week. Rustig en regelmatig werkt beter dan veel.`} data-id="element-4370" data-mp="2u8t8uiap59u5">
      <div data-id="element-4371" data-mp="2kige5x9640aa">
        <p className="flex items-baseline justify-between text-[14px] text-ink" data-id="element-4372" data-mp="2kiq81vxc2rl9">
          <span data-id="element-4373" data-mp="3hxlzbz8juphd">Deze week</span>
          <span className="tabular-nums text-muted" data-id="element-4374" data-mp="3hynk4vfdaqca">
            {planned} / {POSTS_PER_WEEK}
          </span>
        </p>
        <div className="mt-2 flex gap-1" role="progressbar" aria-valuemin={0} aria-valuemax={POSTS_PER_WEEK} aria-valuenow={planned} aria-label="Berichten ingepland deze week" data-id="element-4375" data-mp="3d5ay8t22oxn8">
          {Array.from({
          length: Math.max(POSTS_PER_WEEK, planned)
        }, (_, i) => <span key={i} className={`h-1.5 flex-1 rounded-full ${i < planned ? 'bg-ink' : 'bg-sand'}`} data-id="element-4376" data-mp="3n8zp4uggnf9q" />)}
        </div>
        {ready > 0 && <p className="mt-2 text-[13px] text-clay" data-id="element-4377" data-mp="3dblb11i0f2kl">{plural(ready, 'post staat', 'posts staan')} klaar om te posten</p>}
      </div>

      <div className="mt-6 border-t border-line pt-5" data-id="element-4378" data-mp="3id0vosg9z72g">
        <p className="text-[14px] text-ink" data-id="element-4379" data-mp="34cgge69kjtdp">Onderwerpen rond deze week</p>
        <ul className="mt-3 space-y-2.5" data-id="element-4380" data-mp="38djtwm459dbr">
          {pillars.map(p => {
          const n = counted.filter(x => x.pillar === p.key).length;
          return <li key={p.key} className="grid grid-cols-[1fr_auto] items-center gap-x-3 gap-y-1" data-id="element-4381" data-mp="12lcyqx19hejn">
                <span className="flex items-center gap-2 text-[13px] text-ink" data-id="element-4382" data-mp="16ldohdtt9c60">
                  <span className={`h-2 w-2 shrink-0 rounded-full ${p.dot}`} aria-hidden="true" data-id="element-4383" data-mp="2r50ncylxt5rq" />
                  {p.label}
                </span>
                <span className="text-[12px] tabular-nums text-muted" data-id="element-4384" data-mp="30u0rewfaqrcs">{n}</span>
                <span className="col-span-2 h-1 overflow-hidden rounded-full bg-sand" data-id="element-4385" data-mp="30w3o1zayfiqh">
                  <span className={`block h-full rounded-full ${p.dot} transition-[width] duration-200 ease-soft`} style={{
                width: `${n / total * 100}%`
              }} data-id="element-4386" data-mp="2w1zjfmp5vmsk" />
                </span>
              </li>;
        })}
        </ul>
        <p className="mt-4 rounded-md bg-shell px-3 py-2.5 text-[13px] leading-relaxed text-muted" data-id="element-4387" data-mp="3js3lhpmpbehg">{advice}</p>
      </div>
    </Panel>;
}